import { useEffect, useRef, useState } from 'react';
import { cn } from '../../../utils';
import SmoothLoader from './Loader/SmoothLoader';

export default function Button({
  className,
  variant = 'primary',
  size = 'md',
  loading = false,
  link = null,
  children,
  disabled,type='submit',
  ...props
}) {
  const [buttonWidth, setButtonWidth] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current && !loading) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, [loading]);

  return (
    <button
      ref={buttonRef}
      type={type}
      className={cn(
        'overflow-none inline-flex items-center justify-center gap-2 rounded-[100px] text-[16px] font-bold leading-[25.6px] tracking-[0.5px] !line-clamp-2 md:!line-clamp-1 disabled:opacity-60',
        variant === 'primary' && 'bg-primary text-white',
        variant === 'outline' && 'border-[1px] border-mid bg-white text-high',
        variant === 'ghost' && 'bg-white text-high hover:bg-gray-200',
        variant === 'text' && ' bg-white text-high',
        size === 'sm' && 'px-6 py-[7px]',
        size === 'md' && 'px-8 py-[9px]',
        size === 'lg' && 'px-8 py-[15px]',
        size === 'xs' && 'px-4 py-[7px] text-[14px]',
        className
      )}
      style={
        loading
          ? { width: buttonWidth, display: 'flex' }
          : { minWidth: 50, display: 'inline-flex' }
      }
      disabled={loading || disabled}
      {...props}
    >
      {loading ? (
        <div className='flex min-h-[25.6px] items-center justify-center'>
          <SmoothLoader variant={variant === 'primary' ? 'dark' : 'light'} />
        </div>
      ) : (
        children
      )}
    </button>
  );
}
